import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenDeleteAction from './communityGardenDelete.action.json' with { type: 'json' }
import { communityGardenObject } from '../communityGardenObject'

const communityGardenDeleteDefinition = defineAction({
  ...communityGardenDeleteAction,

  input: z.object({ id: communityGardenObject.shape.id }),
  output: z.object({}),
})

export default communityGardenDeleteDefinition
